import React from 'react';
import PropTypes from 'prop-types';

export default function Testimonial({ testimonial, url }) {
  return (
    <div className="landing-testimonials-item">
      <p className="landing-testimonial-text" itemProp="reviewBody">
        {`"${testimonial.text}"`}
      </p>
      <div
        className="landing-testimonial-signature"
        itemProp="author"
        itemScope
        itemType="http://schema.org/Person"
      >
        <img
          src={testimonial.image}
          alt="testimonial user"
          className="landing-testimonial-avatar"
          itemProp="itemReviewed"
          content={`${url}#website`}
        />
        <span className="landing-testimonial-name" itemProp="name">
          {testimonial.name}
        </span>
        {' -- '}
        <span className="landing-testimonial-role">{testimonial.role}</span>
      </div>
    </div>
  );
}

Testimonial.propTypes = {
  testimonial: PropTypes.shape({
    image: PropTypes.string,
    text: PropTypes.string,
    role: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  url: PropTypes.string.isRequired,
};
